import React from 'react'
import PageMeta from '../../components/common/PageMeta'
import PageBreadcrumb from '../../components/common/PageBreadCrumb'
import ComponentCard from '../../components/common/ComponentCard'
import ProjectsTable from './table/projectsTable'

const ProjectsPage = () => {
  return (
    <>
    <PageMeta
        title="121 properties"
        description="This is React.js Basic Tables Dashboard page for TailAdmin - React.js Tailwind CSS Admin Dashboard Template"
      />
      <PageBreadcrumb pageTitle="Projects Tabel" />
      <div className="space-y-6 overflow-hidden max-w-full">
        <ComponentCard title="Projects">
          <ProjectsTable />
        </ComponentCard>
      </div>
    </>
  )
}

export default ProjectsPage